import React, { useEffect, useRef, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import moment from 'moment';
import { PrimaryButton, TextBox } from '../../../../Core/FormInput';
import { addReportingNotes, getReportingNotes } from '../../../../Core/Service/ReportScreens-service';
import './reportingNotes.scss';
const JobSingleNote = (props) => {
    return (
        <div className="single-note">
            <div className="msg">{props.note.reportingAccountQueryNotes}</div>
            <div className="footer">
                {props.note.userName} @ {moment(props.note.reportingAccountQueryCreated).format('LLL')}
            </div>
        </div>
    );
};

const ReportNotesModal = (props) => {
    const [state, setState] = useState({
        loading: false,
        notes: [],
        newNote: ''
    });

    const notesContainer = useRef(null);
    const handleClose = () => {
        props.onClose && props.onClose(false);
    };

    const setNewNote = (e) => {
        const newNote = e.target.value;
        setState((st) => ({ ...st, newNote }));
    };

    const addNotesToServer = () => {
        let data = {
            reportingAccountQuerySystemMatchNumber: props.smn,
            reportingAccountQueryCreated: '',
            notes: state.newNote
        };
        addReportingNotes(data).then((res) => {
            if (res.success) {
                setState((st) => ({ ...st, newNote: '' }));
                getJobNotesAndSaveToState();
                props.onClose(true);
            }
        });
    };

    const getJobNotesAndSaveToState = async () => {
        setState((st) => ({ ...st, loading: true }));
        getReportingNotes(props.smn)
            .then((res) => {
                if (res.success) {
                    setState((st) => ({ ...st, notes: res.data.list }));
                }
                notesContainer.current && (notesContainer.current.scrollTop = 0);
            })
            .finally(() => {
                setState((st) => ({ ...st, loading: false }));
            });
    };

    useEffect(() => {
        getJobNotesAndSaveToState();
    }, [props.smn]);

    return (
        <Dialog open={true} onClose={handleClose} maxWidth="md" fullWidth className="dialog-custom reporting-notes-modal">
            <DialogTitle>
                Reporting Account Query Notes ({props.dn})
                <div className="title-header-actions">
                    <PrimaryButton onClick={addNotesToServer} disabled={state.newNote.length === 0}>
                        Add Notes
                    </PrimaryButton>
                    <span className="close-icon" onClick={handleClose}>
                        &times;
                    </span>
                </div>
            </DialogTitle>
            <DialogContent>
                <TextBox label="New Note" required={false} onChange={setNewNote} value={state.newNote} autoFocus={true} />
                <div className="notes-container custom-scroll" ref={notesContainer}>
                    {state.loading && <label>Loading...</label>}
                    {state.notes.map((n, i) => (
                        <JobSingleNote key={i} note={n} />
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ReportNotesModal;
